import React from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { setErrors } from 'actions/setting/bankAccount';
import { find } from 'lodash';
import styles from './style.css';

class FormField extends React.Component {
  render() {
    const {
      input,
      meta,
      placeholder,
      readOnly,
      maxLength,
      showEyeIcon,
      customError,
    } = this.props;

    const { touched, error } = meta;
    return (
      <div
        className={
          touched
            ? error || customError
              ? `has-feedback ${styles['has-error']}`
              : 'has-feedback'
            : showEyeIcon
            ? 'has-feedback'
            : ''
        }
      >
        <input
          {...input}
          type="text"
          readOnly={readOnly}
          maxLength={maxLength}
          className="form-control"
          placeholder={placeholder}
          onChange={this._onChange}
          onKeyPress={this._onKeyPress}
        />

        {touched && (error || customError) && (
          <div>
            <small className={`${styles['text-error']}`}>
              {error || customError}
            </small>
            <span className="form-control-feedback glyphicon glyphicon-remove" />
          </div>
        )}
      </div>
    );
  }

  _onKeyPress = e => {
    const { positiveNumberOnly, maxFractionDigits, letterOnly } = this.props;
    // allow only specific chars
    // whether the input is not valid (e.g. 123, or 1.234.1234) should be handled on onChange

    if (positiveNumberOnly) {
      let numberRegex;
      if (maxFractionDigits === 0) {
        numberRegex = /[0-9]/;
      } else {
        numberRegex = /[0-9.]/;
      }

      if (!numberRegex.test(e.key)) {
        e.preventDefault();
      }
    }

    // allow letters only
    if (letterOnly) {
      const letterRegex = /^[a-zA-Z\s]*$/;
      if (!letterRegex.test(e.key)) {
        e.preventDefault();
      }
    }
  };

  _onChange = e => {
    const nextVal = e.target.value;
    const {
      positiveNumberOnly,
      input: { onChange },
      maxFractionDigits,
    } = this.props;
    if (isNaN(nextVal) && positiveNumberOnly) {
      // case if one digit < 0 integer
      if (nextVal === '-') {
        onChange(e, '');
      } else {
        // no op. invalid change
      }
    } else if (maxFractionDigits !== undefined) {
      // we must check also if == 0, so we check using undefined instead of comparing zero values (!maxFractionDigits
      const dotPosition = nextVal.indexOf('.');
      if (
        dotPosition !== -1 &&
        nextVal.length - dotPosition - 1 > maxFractionDigits
      ) {
        // no op. invalid change
      } else {
        onChange(e, nextVal);
      }
    } else {
      onChange(e, nextVal);
    }

    this._validateCustomError(e);
  };

  _validateCustomError = e => {
    const { bankAccounts, selectedBankAccount, errors } = this.props;

    const updatedErrors = { ...errors };

    const selectedBankAccountId =
      selectedBankAccount !== null ? selectedBankAccount.bankAccId : null;

    if (e.target.name === 'accountNumber') {
      const bankAccountExist = find(bankAccounts, function(ba) {
        return (
          ba.business_bank_account_id !== selectedBankAccountId &&
          ba.account_holder_number === e.target.value
        );
      });

      if (bankAccountExist !== undefined) {
        updatedErrors.accountNumber = 'Account number already exists';
      } else {
        updatedErrors.accountNumber = '';
      }
    }

    this.props.dispatch(setErrors(updatedErrors));
  };
}

function mapStateToProps(state) {
  const {
    errors,
    bankAccountDetail,
    bankAccountLists,
  } = state.setting.bankAccount;

  return {
    errors,
    bankAccounts: bankAccountLists,
    selectedBankAccount: bankAccountDetail,
    bankAccountForm: getFormValues('bankAccountForm')(state),
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormField);
